module.exports = __webpack_public_path__ + "static/img/img-motor-color-1.7f01eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-motor-color-1.png
// module id = iBv1
// module chunks = 36